import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../../components'
import './filter.scss'
import FilterCiclo from './filterCiclo'
import FilterData from './filterData'
import { filterHandle, putFiltersProvisorio, setFiltersProvisorio } from '../redux/csatconcorrentesActions'

export default () => {
  const dispatch = useDispatch()
  const { projeto, empresa, filters, listas: {typeSearch}, ciclos, sistema } = useSelector(state=> state.layoutState)
  const { filtersProvisorio } = useSelector(state=> state.csatconcorrentesState)

  const nls = require(`../nls/${sistema.idioma}.json`)
  
  useEffect(()=> {
    let filtros = filters
    if (!filters?.ciclo?.anoMes  && ciclos.length) {
      //filtros = {...filtersProvisorio, ...filtros, ciclo: ciclos[ciclos.length - 1]}
      filtros = {...filtersProvisorio, ...filtros, ciclo: ciclos[0]}
    }
    dispatch(setFiltersProvisorio(filtros))
  }, [ciclos])

  const handleSearching = (params) => {
    handleSearchingValid(params)
    // if (params.typeSelect.id === 'Ciclo') {
    // }
    // if (params.typeSelect.id === 'Data') {
    //   if (params.dataInicial && params.dataFinal) {
    //     handleSearchingValid(params)
    //   }
    // }
  }
  
  const handleSearchingValid = (params) => {
      dispatch(filterHandle({projetoID: projeto.id, empresaId: empresa.empresaId, params, filtersProvisorio, typeSelect: params.typeSelect, idioma: sistema.idiomaIdValue}))
  }
  
  const contentFilterType = (e) => {
    switch (e?.id) {
      case 'Ciclo':
        return <FilterCiclo />;
      case 'Data':
        return <FilterData />;
      default:
        return;
    }
  }
  
  return (
    <div className='box-csatconcorrentes-search box-content'>
      <div className='box-csatconcorrentes-search-box'>
        <div className='box-csatconcorrentes-search-type'>
          {
            typeSearch.map((type)=> {
              return <Button
  data-cy='filter-type'
  data-cy-key={
    type.id === 'Ciclo'
      ? 'ciclo'
      : type.id === 'Data'
        ? 'data'
        : undefined
  }
  data-cy-selected={
    type.id === filtersProvisorio?.typeSelect?.id
      ? 'true'
      : 'false'
  }
  color={'primary'}
  type={type.id === filtersProvisorio?.typeSelect?.id?'btn':'link'}
  size='small'
                onClick={()=> dispatch(putFiltersProvisorio({name: 'typeSelect', value: type}))}
                key={type.id}
              >
                {type.label}
              </Button> 
            })
          }
          <p data-cy='filter-type-label'>{filtersProvisorio?.typeSelect?.text === 'Filtrar por Ciclo' ? nls.filtrarporciclo : nls.filtrarpordata}</p>
        </div>
        <div>
          {contentFilterType(filtersProvisorio?.typeSelect)}
        </div>

      </div>
      <div className='box-csatconcorrentes-search-action'>
        <Button
  data-cy='filter-search'
  color='primary'
  size='large'
  onClick={()=> handleSearching(filtersProvisorio)}
        >{nls.pesquisar}</Button>          
      </div>
    </div>
  )
}
